import type { SVGProps } from 'react';

const SvgEdit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="m18.29 6.072-1.17-1.17a3 3 0 0 0-4.24 0l-8 8c-.57.57-.88 1.32-.88 2.12v3.17c0 .55.45 1 1 1h3.17c.8 0 1.55-.31 2.12-.88l8-8c.57-.57.88-1.32.88-2.12s-.31-1.55-.88-2.12m-1.41 2.83-8 8-2.59-2.59 8-8a.996.996 0 0 1 1.41 0l1.17 1.17c.19.19.29.44.29.71s-.1.52-.29.71z"
    />
  </svg>
);
export default SvgEdit;
